import { render, staticRenderFns } from "./MedicalAlertEdit.vue?vue&type=template&id=ef0fca16&scoped=true&"
import script from "./MedicalAlertEdit.vue?vue&type=script&lang=js&"
export * from "./MedicalAlertEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0fca16",
  null
  
)

export default component.exports